/*
 * View for the user contexts modal
 */

define([
  "jquery",
  "marionette",
  "modules/admin/userAdministration/userDetails/contextMapDisplay/template/contextMapTemplate.html",
], function ($, Marionette, ContextMapTemplate) {
  "use strict";

  const ContextMapView = {};

  ContextMapView.contextMapView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: ContextMapTemplate,
    events: {
      "click .chkContext": function (e) {
        const contextId = $(e.target).attr("data-contextId");
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:context", contextId);
      },
    },
  });

  return ContextMapView;
});
